import React, { useEffect, useState } from "react";
import styles from "./AlreadyRegistered.module.css";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, TextInputField } from "evergreen-ui";
import { useNavigate } from "react-router-dom";
import { loadData } from "../../../Utils/localStorage";
import { ToastContainer, toast } from "react-toastify";
import { login_success } from "../../../Redux/Auth/Auth.action";
import { validateEmail } from "../../../Utils/Validation";
import { PRODUCT } from "../../../Utils/variables";
export const AlreadyRegistered = () => {
  const { isLogin } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [localEmail, setlocalEmail] = useState("");
  const [tradeLicenseNumber, setTradeLicenseNumber] = useState("");
  const [isvisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      toast.error("Please Enter Valid Email Address");
    } else if (password == "") {
      toast.error("Please Enter Password");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/login", {
        method: "POST",
        body: JSON.stringify({ email: email, password: password }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setIsVisible(false);
          let status = res.status;
          if (status == true) {
            localStorage.clear();
            toast(`${res.message}`, {
              type: "success",
            });
            dispatch(login_success({vendorId: res.response.id, vendorName: res.response?.user[0]?.vendor_name}));
            getAllCommunities();
            navigate("/rfqs");
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
          }
        })
        .catch((err) => {
          setIsVisible(false);
          console.log("e", err);
        });
    }
  };
  const getAllCommunities = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/allcommunities", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        localStorage.setItem("allCommunities", JSON.stringify(res.response));
      })
      .catch((err) => console.log("e", err));
  };
  const maskEmail = (eemail) => {
    const emailsArr = eemail.split(',')
    let emailString = ''
    emailsArr.forEach(email => {
      if (email) {
        let str = email;
        str = str.split("");
        let finalArr = [];
        let len = str.indexOf("@");
        str.forEach((item, pos) => {
          pos >= 2 && pos <= len - 3
            ? finalArr.push("*")
            : finalArr.push(str[pos]);
        });
        emailString = emailString == ''? finalArr.join(""): emailString +', '+ finalArr.join("");
      }
    })
    return emailString
  };
  useEffect(() => {
    document.title = PRODUCT + " - Already Registered";
    setlocalEmail(loadData("email"));
    setTradeLicenseNumber(loadData("LicenseNumber"));
    if (isLogin) {
      navigate("/rfqs");
    }
  }, []);
  return (
    <>
      <div
        className={
          PRODUCT === "STRATUM" || PRODUCT === "DANUBE"
            ? styles.mainDivARST
            : styles.mainDivAR
        }
      >
        <div className={styles.centerDivAR}>
          <h1>ALREADY REGISTERED</h1>
          <p>
            You already have an account with us for the entered <br />
            <b>
              Trade License Number : {tradeLicenseNumber && tradeLicenseNumber}
            </b>
            <br /> Please sign in with{" "}
            <b>Email ID{localEmail.split(',').length > 1? 'S': ''}: {maskEmail(localEmail)} </b> to continue.
          </p>
          <div className={styles.mainContentAR}>
            <form>
              <TextInputField
                className={styles.inputDiv}
                label="Email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextInputField
                type="password"
                className={styles.inputDiv}
                label="Password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Link className={styles.forgotPasswordAR} to={"/forgetpassword"}>
                <p>Forgot Password?</p>
              </Link>
              <div>
                {!isvisible ? (
                  <Button
                    className={styles.loginBtnAR}
                    onClick={handleSubmit}
                    id="poppinFontLogin"
                  >
                    LOGIN
                  </Button>
                ) : (
                  <Button
                    className={styles.loginBtnDisabledAR}
                    id="poppinFontLogin"
                    onClick={handleSubmit}
                  >
                    <i
                      className="fa fa-spinner fa-spin "
                      style={{ color: "white", marginRight: "10px" }}
                    ></i>
                    LOGIN
                  </Button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </>
  );
};
